(function () {
  'use strict';

  const elementName = 'aa-custom-mobile-menu';

  if (customElements.get(elementName)) return;

  class AACustomMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;

      this.dataset.bound = 'true';

      this.header = this.closest(
        'archetype-custom-header'
      );

      this.menuToggle =
        this.header?.querySelector(
          '[data-aa-mobile-menu-toggle]'
        ) || null;

      this.closeButton = this.querySelector(
        '[data-aa-mobile-close]'
      );

      this.searchButton = this.querySelector(
        '[data-aa-mobile-search]'
      );

      this.wishlistButton = this.querySelector(
        '[data-aa-mobile-wishlist]'
      );

      this.topButtons = Array.from(
        this.querySelectorAll(
          '[data-aa-mobile-top]'
        )
      );

      this.topContents = Array.from(
        this.querySelectorAll(
          '[data-aa-mobile-top-content]'
        )
      );

      this.panels = Array.from(
        this.querySelectorAll(
          '[data-aa-mobile-panel]'
        )
      );

      this.rootPanel = this.querySelector(
        '[data-aa-mobile-panel][data-panel-id="root"]'
      );

      this.defaultTop =
        this.dataset.defaultTop || '';

      this.activeTop =
        this.defaultTop;

      this.history = [
        {
          panelId: 'root',
          menuScope: 'root'
        }
      ];
      this.hideTimer = 0;
      this.focusTimer = 0;
      this.restoreFocusOnClose = true;

      this.handleClick =
        this.handleClick.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.handleResize =
        this.handleResize.bind(this);

      this.addEventListener(
        'click',
        this.handleClick
      );

      document.addEventListener(
        'keydown',
        this.handleKeydown
      );

      window.addEventListener(
        'resize',
        this.handleResize
      );

      this.switchTop(
        this.activeTop ||
        this.defaultTop,
        false
      );

      this.resetNavigation();
    }

    disconnectedCallback() {
      window.clearTimeout(
        this.hideTimer
      );

      window.clearTimeout(
        this.focusTimer
      );

      this.removeEventListener(
        'click',
        this.handleClick
      );

      document.removeEventListener(
        'keydown',
        this.handleKeydown
      );

      window.removeEventListener(
        'resize',
        this.handleResize
      );
    }

    open() {
      window.clearTimeout(
        this.hideTimer
      );

      window.clearTimeout(
        this.focusTimer
      );

      this.restoreFocusOnClose = true;

      this.hidden = false;

      this.setAttribute(
        'aria-hidden',
        'false'
      );

      this.activeTop =
        this.defaultTop;

      this.resetNavigation();

      this.switchTop(
        this.defaultTop,
        false
      );

      document.documentElement.classList.add(
        'aa-mobile-menu-open'
      );

      window.requestAnimationFrame(() => {
        this.classList.add(
          'is-open'
        );

        this.focusTimer =
          window.setTimeout(() => {
            this.closeButton?.focus({
              preventScroll: true
            });
          }, 80);
      });
    }

    close() {
      if (this.hidden) return;

      window.clearTimeout(
        this.hideTimer
      );

      window.clearTimeout(
        this.focusTimer
      );

      this.classList.remove(
        'is-open'
      );

      document.documentElement.classList.remove(
        'aa-mobile-menu-open'
      );

      this.hideTimer =
        window.setTimeout(() => {
          this.hidden = true;

          this.setAttribute(
            'aria-hidden',
            'true'
          );

          this.resetNavigation();

          if (
            this.restoreFocusOnClose &&
            window.innerWidth < 990
          ) {
            this.menuToggle?.focus({
              preventScroll: true
            });
          }

          this.restoreFocusOnClose = true;
        }, 320);
    }

    handleClick(event) {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      if (!target) return;

      const closeButton = target.closest(
        '[data-aa-mobile-close]'
      );

      if (
        closeButton &&
        this.contains(closeButton)
      ) {
        event.preventDefault();

        this.restoreFocusOnClose = true;

        this.header?.closeMobileMenu?.();
        return;
      }

      const topButton = target.closest(
        '[data-aa-mobile-top]'
      );

      if (
        topButton &&
        this.contains(topButton)
      ) {
        event.preventDefault();

        this.switchTop(
          topButton.getAttribute(
            'data-top-id'
          ),
          true
        );

        return;
      }

      const forwardButton = target.closest(
        '[data-aa-mobile-forward]'
      );

      if (
        forwardButton &&
        this.contains(forwardButton)
      ) {
        event.preventDefault();

        this.goForward(
          forwardButton.getAttribute(
            'data-target-panel'
          ),
          forwardButton.getAttribute(
            'data-aa-mobile-menu-scope'
          )
        );

        return;
      }

      const backButton = target.closest(
        '[data-aa-mobile-back]'
      );

      if (
        backButton &&
        this.contains(backButton)
      ) {
        event.preventDefault();

        this.goBack();
        return;
      }

      const searchButton = target.closest(
        '[data-aa-mobile-search]'
      );

      if (
        searchButton &&
        this.contains(searchButton)
      ) {
        event.preventDefault();

        this.openSearch();
        return;
      }

      const wishlistButton = target.closest(
        '[data-aa-mobile-wishlist]'
      );

      if (
        wishlistButton &&
        this.contains(wishlistButton)
      ) {
        event.preventDefault();

        this.openWishlist();
        return;
      }

      const finalLink = target.closest(
        '[data-aa-mobile-final-link]'
      );

      if (
        finalLink &&
        this.contains(finalLink)
      ) {
        this.restoreFocusOnClose = false;

        this.header?.closeMobileMenu?.();
      }
    }

    switchTop(
      topId,
      shouldScroll = true
    ) {
      if (!topId) return;

      const selectedButton =
        this.topButtons.find((button) => {
          return (
            button.getAttribute(
              'data-top-id'
            ) === topId
          );
        });

      const selectedContent =
        this.topContents.find((content) => {
          return (
            content.getAttribute(
              'data-aa-mobile-top-content'
            ) === topId
          );
        });

      if (
        !selectedButton ||
        !selectedContent
      ) {
        return;
      }

      /*
      * A different navigation block must never
      * inherit nested-panel history from the
      * previously selected block.
      */
      if (
        this.activeTop &&
        this.activeTop !== topId
      ) {
        this.resetNavigation();
      }

      this.activeTop = topId;

      this.topButtons.forEach((button) => {
        const active =
          button === selectedButton;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

        button.setAttribute(
          'tabindex',
          active ? '0' : '-1'
        );
      });

      this.topContents.forEach((content) => {
        const active =
          content === selectedContent;

        content.hidden = !active;

        content.setAttribute(
          'aria-hidden',
          active ? 'false' : 'true'
        );

        if (active) {
          content.removeAttribute('inert');
        } else {
          content.setAttribute('inert', '');
        }
      });

      if (shouldScroll) {
        selectedButton.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });

        if (this.rootPanel) {
          this.rootPanel.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }
    }

    goForward(
      targetId,
      requestedMenuScope
    ) {
      if (!targetId) return;

      const menuScope =
        requestedMenuScope ||
        this.activeTop;

      /*
      * Do not allow a button belonging to one
      * navigation block to open a panel from
      * another navigation block.
      */
      if (
        !menuScope ||
        menuScope !== this.activeTop
      ) {
        return;
      }

      const currentPanel =
        this.getCurrentPanel();

      const targetPanel =
        this.findPanel(
          targetId,
          menuScope
        );

      if (
        !currentPanel ||
        !targetPanel ||
        currentPanel === targetPanel
      ) {
        return;
      }

      this.setPanelState(
        currentPanel,
        'before'
      );

      this.setPanelState(
        targetPanel,
        'active'
      );

      const lastEntry =
        this.history[
          this.history.length - 1
        ];

      if (
        !lastEntry ||
        lastEntry.panelId !== targetId ||
        lastEntry.menuScope !== menuScope
      ) {
        this.history.push({
          panelId: targetId,
          menuScope
        });
      }

      targetPanel.scrollTop = 0;

      const focusTarget =
        targetPanel.querySelector(
          '[data-aa-mobile-back]'
        ) ||
        targetPanel.querySelector(
          'button, a[href]'
        );

      window.clearTimeout(
        this.focusTimer
      );

      this.focusTimer =
        window.setTimeout(() => {
          focusTarget?.focus({
            preventScroll: true
          });
        }, 320);
    }

    goBack() {
      if (
        this.history.length <= 1
      ) {
        return;
      }

      const currentEntry =
        this.history.pop();

      const previousEntry =
        this.history[
          this.history.length - 1
        ];

      const currentPanel =
        this.findPanel(
          currentEntry.panelId,
          currentEntry.menuScope
        );

      const previousPanel =
        this.findPanel(
          previousEntry.panelId,
          previousEntry.menuScope
        );

      if (
        !currentPanel ||
        !previousPanel
      ) {
        this.resetNavigation();
        return;
      }

      this.setPanelState(
        currentPanel,
        'after'
      );

      this.setPanelState(
        previousPanel,
        'active'
      );

      const targetSelector =
        `[data-target-panel="${this.escapeSelector(
          currentEntry.panelId
        )}"]` +
        `[data-aa-mobile-menu-scope="${this.escapeSelector(
          currentEntry.menuScope
        )}"]`;

      const previousTrigger =
        previousPanel.querySelector(
          targetSelector
        );

      window.clearTimeout(
        this.focusTimer
      );

      this.focusTimer =
        window.setTimeout(() => {
          previousTrigger?.focus({
            preventScroll: true
          });
        }, 320);
    }

    resetNavigation() {
      this.history = [
        {
          panelId: 'root',
          menuScope: 'root'
        }
      ];

      this.panels.forEach((panel) => {
        const panelId =
          panel.getAttribute(
            'data-panel-id'
          );

        this.setPanelState(
          panel,
          panelId === 'root'
            ? 'active'
            : 'after'
        );
      });

      if (this.rootPanel) {
        this.rootPanel.scrollTop = 0;
      }
    }

    setPanelState(
      panel,
      state
    ) {
      if (!panel) return;

      panel.classList.remove(
        'is-active',
        'is-before',
        'is-after'
      );

      panel.classList.add(
        `is-${state}`
      );

      const active =
        state === 'active';

      panel.setAttribute(
        'aria-hidden',
        active ? 'false' : 'true'
      );

      if (active) {
        panel.removeAttribute(
          'inert'
        );
      } else {
        panel.setAttribute(
          'inert',
          ''
        );
      }
    }

    findPanel(
      panelId,
      menuScope
    ) {
      if (panelId === 'root') {
        return this.rootPanel;
      }

      return this.panels.find((panel) => {
        const matchingPanel =
          panel.getAttribute(
            'data-panel-id'
          ) === panelId;

        const matchingScope =
          panel.getAttribute(
            'data-aa-mobile-menu-scope'
          ) === menuScope;

        return (
          matchingPanel &&
          matchingScope
        );
      });
    }

    getCurrentPanel() {
      const currentEntry =
        this.history[
          this.history.length - 1
        ];

      if (!currentEntry) {
        return this.rootPanel;
      }

      return this.findPanel(
        currentEntry.panelId,
        currentEntry.menuScope
      );
    }

    openSearch() {
      const searchTrigger =
        this.header?.querySelector(
          '.aa-header__mobile-search-button[data-aa-search-open]'
        );

      if (!searchTrigger) return;

      this.restoreFocusOnClose = false;

      this.header?.closeMobileMenu?.();

      window.setTimeout(() => {
        searchTrigger.click();
      }, 340);
    }

    openWishlist() {
      const wishlistUrl =
        this.wishlistButton?.getAttribute(
          'href'
        ) || '/pages/wishlist';

      this.restoreFocusOnClose = false;

      this.header?.closeMobileMenu?.();

      window.setTimeout(() => {
        window.location.assign(
          wishlistUrl
        );
      }, 340);
    }

    handleKeydown(event) {
      if (
        this.hidden ||
        !this.classList.contains(
          'is-open'
        )
      ) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();

        if (
          this.history.length > 1
        ) {
          this.goBack();
        } else {
          this.restoreFocusOnClose = true;

          this.header?.closeMobileMenu?.();
        }

        return;
      }

      if (
        event.key !== 'Tab'
      ) {
        return;
      }

      this.trapFocus(event);
    }

    trapFocus(event) {
      const activePanel =
        this.getCurrentPanel();

      if (!activePanel) return;

      const topbarFocusable =
        Array.from(
          this.querySelectorAll(
            '.aa-mobile-nav__topbar button:not([disabled])'
          )
        );

      const panelFocusable =
        Array.from(
          activePanel.querySelectorAll(
            [
              'button:not([disabled])',
              'a[href]',
              'input:not([disabled])',
              'select:not([disabled])',
              'textarea:not([disabled])',
              '[tabindex]:not([tabindex="-1"])'
            ].join(',')
          )
        ).filter((element) => {
          return (
            !element.closest('[hidden]') &&
            !element.closest('[inert]') &&
            element.offsetParent !== null
          );
        });

      const focusable = [
        ...topbarFocusable,
        ...panelFocusable
      ].filter((element, index, items) => {
        return (
          items.indexOf(element) === index &&
          element.offsetParent !== null
        );
      });

      if (!focusable.length) {
        event.preventDefault();

        this.closeButton?.focus({
          preventScroll: true
        });

        return;
      }

      const first =
        focusable[0];

      const last =
        focusable[
          focusable.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();

        last.focus({
          preventScroll: true
        });

        return;
      }

      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();

        first.focus({
          preventScroll: true
        });
      }
    }

    handleResize() {
      if (
        window.innerWidth >= 990 &&
        !this.hidden
      ) {
        this.restoreFocusOnClose = false;

        this.header?.closeMobileMenu?.();
      }
    }

    escapeSelector(value) {
      const stringValue =
        String(value || '');

      if (
        window.CSS &&
        typeof window.CSS.escape ===
          'function'
      ) {
        return window.CSS.escape(
          stringValue
        );
      }

      return stringValue.replace(
        /["\\]/g,
        '\\$&'
      );
    }
  }

  customElements.define(
    elementName,
    AACustomMobileMenu
  );
})();